import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/pro-light-svg-icons';
import { Text, useMediaQuery, useTheme } from '@querodelivery/uni-react';
import styles from './order-proxy-phone.module.scss';
import { OrderProxyPhoneModal } from '@/_features/deliveries/componentes/order-proxy-phone-modal/order-proxy-phone-modal';
import { proxyPhoneLabel } from '@/Utils/FnUtils';

export interface DeliveryProxy {
  phone: string;
  proxyId: string;
}

interface OrderProxyPhoneProps {
  proxy?: DeliveryProxy;
}

export function OrderProxyPhone({ proxy }: OrderProxyPhoneProps) {
  const isMobile = useMediaQuery('lg-down');
  const { color } = useTheme();
  const [isModalOpen, setIsModalOpen] = useState(false);

  if (!proxy) {
    return null;
  }

  const textVariant = isMobile ? 'bodyXs' : 'bodySm';
  const formattedPhone = proxyPhoneLabel(proxy.phone) || proxy.phone;

  return (
    <>
      <div className={styles.orderProxyPhone}>
        <Text
          as="span"
          variant={textVariant}
          className={styles.label}
          fontWeight="medium"
        >
          Telefone:
        </Text>

        <div className={styles.valueGroup}>
          <div className={styles.valueContent}>
            <a className={styles.phoneNumber} href={`tel:${proxy.phone}`}>
              <Text as="span" variant={textVariant} fontWeight="bold">
                {formattedPhone}
              </Text>
            </a>
            <Text
              as="span"
              variant={textVariant}
              className={styles.label}
              fontWeight="medium"
            >
              Cód. solicitado:
            </Text>
            <Text as="span" variant={textVariant} fontWeight="bold">
              {proxy.proxyId}
            </Text>
          </div>

          <button
            type="button"
            className={styles.infoButton}
            onClick={() => setIsModalOpen(true)}
            aria-label="Saiba como funciona o telefone proxy"
          >
            <FontAwesomeIcon
              icon={faCircleInfo}
              color={color['color-base-icon']}
              aria-hidden
            />
          </button>
        </div>
      </div>

      <OrderProxyPhoneModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        proxy={proxy}
        isMobile={isMobile}
      />
    </>
  );
}
